/* eslint-disable no-console */

import { rootApi } from '../rootApi';

export const languageApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllLanguages: builder.query({ 
      query: () => {
        return {
          url: 'v1/systemdefinitions/getlanguages',
          method: 'GET', 
        };
      },
      transformResponse: (response) => {
      console.log('🔍 getAllLanguages - Transform Response:', response);

        if (response && response.data && Array.isArray(response.data.items)) {
          console.log('✅ getAllLanguages - Extracted data array with', response.data.items.length, 'items');
          return response.data.items;
        }
        if (Array.isArray(response)) {
          console.log('✅ getAllLanguages - Response is already an array with', response.length, 'items');
          return response; 
        }
        console.warn('⚠️ getAllLanguages - Response structure not as expected, returning empty array. Response:', response);
        return [];
      },
      onQueryStarted: async (arg, { queryFulfilled }) => {
        console.log('🚀 getAllLanguages query started');
        try {
          const { data } = await queryFulfilled;
          console.log('✅ getAllLanguages query fulfilled, data:', data);
        } catch (error) {
          console.error('❌ getAllLanguages query failed:', error);
        }
      },
      providesTags: [{ type: 'Language', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetAllLanguagesQuery,
} = languageApi;